import React from "react";

import styles from "./styles/Footer.module.css";

function Footer() {
  return (
    <footer className={styles.container}>
      <p>Copyright © 2022 Brian Sanchez - Todos los derechos reservados.</p>
    </footer>
  );
};
  
export default Footer;